// extracted by mini-css-extract-plugin
module.exports = {"image":"_37Nhva","title":"_2n4awH","desc":"_1RAtda","content":"FNfYT-","info":"_1WxD3Y","button":"_2odm-U"};